import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerRequestDataService {

  constructor(private http: HttpClient,
    private dataService: DataService) { }


  save(data: any) {
    return this.dataService.post('/api/Request/SaveRequest', data);
  };

  getKMLFiles() {
    return this.dataService.getRecord('/api/coverage/getKMLFiles');
  }

  getRequestDetail(id: number) {
    return this.dataService.getRecord('/api/Request/getrequestdetail/' + id);
  };
}
